<template>
  <v-col
    :id="`agent-${agentCode}`"
    :ref="`agent-${agentCode}`"
    class="agent-dr"
  >
    <v-row class="agent-item">
      <v-col
        cols="8"
        align-self="center"
        class="py-sm-2 agent-name-top"
        :class="agentActive ? 'agent-active' : 'agent-not-active'"
      >
        <div class="agent-name">
          <v-switch
            v-model="agentActive"
            color="primary"
            hide-details
            class="ml-5 my-0 pa-0 d-inline-flex"
            :class="`switcher-${index}`"
            @change="removeAgent"
          ></v-switch>
          <nuxt-link
            :to="`/personal/myboard.aspx?agentscodes=${agentCode}`"
            title="הצג משרות לסוכן"
            :event="agentActive ? 'click' : ''"
            :class="agentActive ? '' : 'disabledLink'"
          >
            <span class="agent-name-shorten"><slot name="name"></slot></span>
          </nuxt-link>
        </div>
      </v-col>

      <v-col
        align-self="center"
        class="text-left"
        :class="
          $vuetify.breakpoint.smAndUp ? 'text-left pb-0 pb-md-3' : 'pa-0 px-2'
        "
      >
        <v-btn
          icon
          color="primary"
          v-if="!agentActive"
          class="mx-2"
          @click="deleteAgent"
          title="מחיקת סוכן"
        >
          <!-- <v-icon>mdi-trash-can-outline </v-icon> -->
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <nuxt-link
          :to="`/personal/smartalerts/?agentcode=${agentCode}`"
          class="text-decoration-none"
          :class="[
            `edit-agent-${index}`,
            agentActive ? 'agent-active' : 'agent-not-active',
          ]"
          :title="`ערוך סוכן `"
        >
          <v-icon class="icon-shape-1" size="13"></v-icon>
          <span v-show="$vuetify.breakpoint.smAndUp">עריכת הגדרות</span>
        </nuxt-link>
        <nuxt-link
          :to="`/personal/myboard.aspx?agentscodes=${agentCode}`"
          class="text-decoration-none"
          :class="agentActive ? 'agent-active' : 'agent-not-active'"
          v-show="$vuetify.breakpoint.smAndUp"
          :title="`הצג משרות לסוכן `"
          :event="agentActive ? 'click' : ''"
        >
          <v-icon class="" color="lightBlack" size="50">
            mdi-chevron-left
          </v-icon>
        </nuxt-link>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import {
  SMART_ALERTS_REMOVE,
  DELETE_AGENT,
  SMART_ALERTS_ACTIVATE,
} from '@/lib/api.js';
export default {
  name: 'AgentItem',
  props: {
    agentStatus: {
      type: Boolean,
      default: false,
      required: true,
    },
    agentCode: {
      type: Number,
      default: 1,
      required: true,
    },
    index: {
      type: Number,
      default: 0,
      required: false,
    },
  },
  data() {
    return {
      flipped: false,
      agentActive: this.agentStatus,
    };
  },
  watch: {
    $props: {
      handler: function () {
        this.agentActive = this.agentStatus;
      },
      deep: true,
    },
  },
  computed: {
    setSatus: {
      get() {
        return this.agentStatus;
      },
    },
  },
  methods: {
    async removeAgent() {
      this.$nuxt.$loading.start();
      const active = this.agentActive;
      try {
        const response = await this.$axios.post(
          !active ? SMART_ALERTS_REMOVE : SMART_ALERTS_ACTIVATE,
          this.agentCode
        );
        if (response.data.IsError) {
          throw 'שגיאה';
        }
        await this.$auth.fetchUser();
        this.$nuxt.$loading.finish();
      } catch (e) {
        console.log(e);
        this.$nuxt.$loading.finish();
      }
    },
    async deleteAgent() {
      this.$nuxt.$loading.start();
      try {
        // const response = await this.$axios.delete(DELETE_AGENT + `?agentCode=${this.agentCode}`,
        const response = await this.$axios.delete(
          `${DELETE_AGENT}?agentCode=${this.agentCode}`,
          {
            method: 'delete',
          }
        );
        if (response.data.IsError) {
          throw 'שגיאה';
        }

        await this.$auth.fetchUser();

        document.querySelector(`#agent-${this.agentCode}`).style.display =
          'none';

        this.$nuxt.$loading.finish();
      } catch (e) {
        console.log(e);
        this.$nuxt.$loading.finish();
      }
    },
    /** Refresh the data provided by fetch */
    async refresh() {
      await this.$nuxt.refresh();
    },
  },
};
</script>

<style  lang="scss" scoped>
// $timeTohide:0.2s;

// .agent-dr {
//   -webkit-transition: all $timeTohide ease-in-out;
//   -moz-transition: all  $timeTohide  ease-in-out;
//   -ms-transition: all  $timeTohide   ease-in-out;
//   -o-transition: all  $timeTohide   ease-in-out;
//   transition: all  $timeTohide ease-in-out;
// }
// .agent-dr.out {
//   zoom: 1;
//   filter: alpha(opacity=0);
//   opacity: 0;
//   height: 0;
//   overflow: hidden;
// }
.agent-item {
  border: 2px solid $gray-2;
  flex-direction: row;
  flex-wrap: nowrap;
}
.agent-not-active {
  opacity: 0.6;
  filter: grayscale(100%);
}
.agent-name-top {
  position: relative;
  & .agent-name-icon {
    position: absolute;
    left: 0;
    top: 12%;
  }
}
.agent-name {
  display: flex;
  position: relative;
  align-items: center;
  padding: 10px 5px;

  & a span {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 95%;
  }

  & a {
    width: 100%;
    line-height: 1;
    text-decoration: none;
    padding-left: 30px;
    font-size: 18px;
    @media (min-width: 600px) {
      font-size: 24px;
    }
  }
  @media (min-width: 600px) {
    margin-left: 30px;
    padding: 10px 0;
  }
  @media (min-width: 768px) {
    margin-left: 30px;
    padding: 10px 0;
  }
}
</style>
